"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.metricTypesMap = exports["default"] = void 0;
var metricTypes = [{
  value: 'quantitative',
  label: 'Quantitative',
  tooltip: 'Displays data from items with pre-determined responses (e.g. multiple choice, Likert scales)'
}, {
  value: 'qualitative',
  label: 'Qualitative',
  tooltip: 'Displays data from opened ended/text fields'
}, {
  value: 'formula',
  label: 'Formulas',
  tooltip: 'Displays user-generated calculations derived from 2 or more quantitative items'
}, {
  value: 'additional_coding',
  label: 'Additional Codings',
  tooltip: 'Displays alternate coding scheme for quantitative data'
}, {
  value: 'summary_usage',
  label: 'Summary Usage',
  tooltip: 'Displays the date/time that participants start and end a Quest, the duration in milliseconds, and date/time last visited'
}, {
  value: 'detailed_usage',
  label: 'Detailed Usage',
  tooltip: 'Displays the duration a participant spent on each item in milliseconds'
}, {
  value: 'correct',
  label: 'Correct',
  tooltip: 'Displays correct answers'
}];
var metricTypesMap = exports.metricTypesMap = metricTypes.reduce(function (obj, item) {
  obj[item.value] = item.label;
  return obj;
}, {});
var _default = exports["default"] = metricTypes;